// TRADE PAGE (Symbol Topic)
export const SYM_SUB_KEY_UIPRICELADDER = '/SYM_SUB_KEY_UIPRICELADDER';
export const SYM_SUB_KEY_UITRADE_WATCHLIST_ITEM = '/SYM_SUB_KEY_UITRADE_WATCHLIST_ITEM';
export const SYM_SUB_KEY_UITRADE_UNDERLYING_HEADER = '/SYM_SUB_KEY_UITRADE_UNDERLYING_HEADER';
export const SYM_SUB_KEY_UITRADE_ANALYSIS_QUOTES = '/SYM_SUB_KEY_UITRADE_ANALYSIS_QUOTES';
export const SYM_SUB_KEY_UITRADE_ORDER_LISTING_ITEM = '/SYM_SUB_KEY_UITRADE_ORDER_LISTING_ITEM';
export const SYM_SUB_KEY_UITRADE_EDITING_SYMBOL = '/SYM_SUB_KEY_UITRADE_EDITING_SYMBOL';

// TRADE PAGE (Symbol Trading Status Topic)
export const SYM_SUB_KEY_UITRADE_TRADING_STATUS = '/SYM_SUB_KEY_UITRADE_TRADING_STATUS';

// CHART PAGE (Symbol Topic)
export const SYM_SUB_KEY_UICHART = '/SYM_SUB_KEY_UICHART';

// MARKET PAGE (Symbol Topic)
export const SYM_SUB_KEY_UIMARKET_WATCHLIST_ITEM = '/SYM_SUB_KEY_UIMARKET_WATCHLIST_ITEM';
export const SYM_SUB_KEY_UIMARKET_POSITIONS_ITEM = '/SYM_SUB_KEY_UIMARKET_POSITIONS_ITEM';
export const SYM_SUB_KEY_UIMARKET_FAVOURITES_ITEM = '/SYM_SUB_KEY_UIMARKET_FAVOURITES_ITEM';
export const SYM_SUB_KEY_UIMARKET_TOPLIST_ITEM_TOPPICKS = '/SYM_SUB_KEY_UIMARKET_TOPLIST_ITEM_TOPPICKS';
export const SYM_SUB_KEY_UIMARKET_TOPLIST_ITEM_TOPGAINERS = '/SYM_SUB_KEY_UIMARKET_TOPLIST_ITEM_TOPGAINERS';
export const SYM_SUB_KEY_UIMARKET_TOPLIST_ITEM_TOPLOSERS = '/SYM_SUB_KEY_UIMARKET_TOPLIST_ITEM_TOPLOSERS';
export const SYM_SUB_KEY_UIMARKET_SIGNALS_ITEM = '/SYM_SUB_KEY_UIMARKET_SIGNALS_ITEM';

// OPTION CHAIN (Option Topic)
export const OPTION_SUB_KEY_UIOPTION = '/OPTION_SUB_KEY_UIOPTION';

// QUOTE (Quote Topic)
export const QUOTE_SUB_KEY_UIQUOTE = '/QUOTE_SUB_KEY_UIQUOTE';

// DEALER (Dealer Topic)
export const DEALER_SUB_KEY_UIDEALER_EXPOSURE = '/DEALER_SUB_KEY_UIDEALER_EXPOSURE';
export const DEALER_SUB_KEY_UIDEALER_LATEST_PRICE = '/DEALER_SUB_KEY_UIDEALER_LATEST_PRICE';
